export const SupplierTypeInput = [
    {key:'Agent', value:'Agent'},
    {key:'Broker', value:'Broker'},
    {key:'Farmer', value:'Farmer'},
]